module.exports = __webpack_public_path__ + "img/01.a5a86c1c.jpg";